module.exports = __webpack_public_path__ + "img/teb.a9d37f7c.png";